"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Field = void 0;
var Field;

(function (Field) {
  Field["Connections"] = "connections";
  Field["Configurations"] = "configurations";
  Field["Fields"] = "fields";
  Field["Location"] = "location";
  Field["Lifecycle"] = "lifecycle";
  Field["Meter"] = "meter";
  Field["Modem"] = "modem";
  Field["Model"] = "model";
  Field["Ports"] = "ports";
  Field["Scheduling"] = "scheduling";
  Field["SLA"] = "sla";
  Field["Weather"] = "weather";
  Field["WorkOrders"] = "workorders";
  Field["Parents"] = "parents";
  Field["Children"] = "children";
})(Field = exports.Field || (exports.Field = {}));

exports.default = Field;